/**
 * ConfirmationBar — Approve/Reject buttons for agent proposals
 * Appears when awaitingApproval is true
 */
import React from 'react';
import { Check, X } from 'lucide-react';

const ConfirmationBar = ({ onApprove, onReject, disabled = false }) => {
  return (
    <div className="flex items-center gap-3 p-3 bg-amber-50 border border-amber-200 rounded-lg">
      <div className="flex-1">
        <p className="text-xs font-medium text-amber-800">
          Kya yeh actions approve karna chahte hain?
        </p>
      </div>
      <button
        onClick={onApprove}
        disabled={disabled}
        className="flex items-center gap-1.5 px-4 py-2 bg-green-500 hover:bg-green-600 text-white rounded-lg text-sm font-medium transition-colors disabled:opacity-50"
      >
        <Check className="w-4 h-4" />
        Haan, karo
      </button>
      <button
        onClick={onReject}
        disabled={disabled}
        className="flex items-center gap-1.5 px-4 py-2 bg-red-500 hover:bg-red-600 text-white rounded-lg text-sm font-medium transition-colors disabled:opacity-50"
      >
        <X className="w-4 h-4" />
        Nahi, ruko
      </button>
    </div>
  );
};

export default ConfirmationBar;
